import type { ClassifyResult } from '../../../shared/api/comment-moderation.api';

/**
 * Склейка разборов, сделанных по одной ссылке за раз.
 *
 * Раньше пять ссылок уезжали одним запросом, и человек две минуты смотрел на
 * серый прямоугольник, не зная, идёт работа или всё зависло. По одной ссылке
 * видно, какой пост разбирается сейчас, а упавшая ссылка не уносит с собой
 * разбор остальных — он уже на экране.
 */
export function mergeClassify(parts: ClassifyResult[]): ClassifyResult {
  const posts: ClassifyResult['posts'] = [];
  const comments: ClassifyResult['comments'] = [];
  const counts: Record<string, number> = {};
  const seen = new Set<string>();

  for (const part of parts) {
    posts.push(...part.posts);
    for (const comment of part.comments) {
      // Один комментарий не может прийти дважды, но ссылку могли вставить
      // дважды — тогда и пост, и его комментарии приедут по второму разу.
      if (seen.has(comment.id)) continue;
      seen.add(comment.id);
      comments.push(comment);
    }
    for (const [key, value] of Object.entries(part.counts ?? {})) {
      counts[key] = (counts[key] ?? 0) + value;
    }
  }

  return { posts, comments, counts };
}

/** Ссылка, которая не разобралась вовсе: показываем её как пост с ошибкой. */
export function failedPost(url: string, error: string): ClassifyResult {
  return { posts: [{ url, username: '', total: 0, error }], comments: [], counts: {} };
}
